export default {
    //tableName: 'portcatalog',

    attributes: {

        id: {
            type: 'number',
            required: true,
            unique: true,
            columnName: 'id'
        },
        name: {
            type: 'string',
            required: true,
        },
        country: {
            type: 'string',
            required: true,
        },
        numberUn: {
            type: 'string',
            required: true,
        },

    },
};


// WEBPACK FOOTER //
// ./src/models/PortCatalog.js